import styled from 'styled-components';

const StylesHeader=styled.div
`
	#page_header
	{
		@media(min-width:1024px)
		{
			font-size:calc(2.5rem*1.5);
		}
	}
`;

export default StylesHeader;